import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";

axios.defaults.baseURL = "https://csa.williambh.com";
// axios.defaults.baseURL = "http://localhost:8000";
createApp(App).use(store).use(router).mount("#app");
